import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.RoomType.Category,
    graphql.schema.RoomTypeCategory
  >({
    [ents.extra.space.RoomType.Category.Standard]:
      graphql.schema.RoomTypeCategory.Standard,
    [ents.extra.space.RoomType.Category.Lab]:
      graphql.schema.RoomTypeCategory.Lab,
    [ents.extra.space.RoomType.Category.LabService]:
      graphql.schema.RoomTypeCategory.LabService,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.RoomTypeCategory,
    ents.extra.space.RoomType.Category
  >({
    [graphql.schema.RoomTypeCategory.Standard]:
      ents.extra.space.RoomType.Category.Standard,
    [graphql.schema.RoomTypeCategory.Lab]:
      ents.extra.space.RoomType.Category.Lab,
    [graphql.schema.RoomTypeCategory.LabService]:
      ents.extra.space.RoomType.Category.LabService,
  }),
)
